export default "__VITE_ASSET__BXJVKVq8__"